<template>
  <div>
    <link rel="stylesheet" href="css/transporation.css"/>
    <div>
      <HeaderOfPage :bgSrc="'banner-places.jpg'" :titleOfPage="'المزارات'" :theDiscription="'المزارات السياحية'"/>
    </div>
    <section class="pages-container">
      <b-container>
        <b-row>
          <b-col>
            <div class="places-select-container">
              <b-row>
                <b-col sm="8" cols="8">
                  <b-form-select v-model="selected" class="mb-3">
                    <b-form-select-option :value="null">اختر المدينه</b-form-select-option>
                    <b-form-select-option value="a">Option A</b-form-select-option>
                    <b-form-select-option value="a">Option A</b-form-select-option>
                    <b-form-select-option value="a">Option A</b-form-select-option>
                    <b-form-select-option value="a">Option A</b-form-select-option>
                  </b-form-select>
                </b-col>
                <b-col sm="4" cols="4">
                  <b-button variant="primary" @click="$router.push('/en/places/place/lebnon')">بحث</b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

      </b-container>
    </section>
    <section class="destinations" style="padding-top:0">
      <b-container>
        <b-row>
          <b-col sm="4" cols="6" v-for="d in 6" :key="d">
            <WorldTourCard/>
          </b-col>
        </b-row>
        <b-row>
          <div class="see-more">
             <b-button variant="primary">المزيد</b-button>
          </div>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script type="text/javascript">
  import HeaderOfPage  from '../global/HeaderOfPage'
  import WorldTourCard from '../global/WorldTourCard'
  export default {
    name : 'Places',
    components: {
      HeaderOfPage,
      WorldTourCard
    },
    data() {
      return {
        selected:null
      }
    }
  }
</script>
